import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by Billion"
      links={[
        {
          key: 'Billion Admin',
          title: 'Billion Admin',
          href: 'https://billion.live/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
